module.exports = __webpack_public_path__ + "img/6514.a64def63.jpg";